export class IsViewEdit {
    isView: boolean;
    isEdit: boolean;
    isaEmployeeNew: boolean;
    isEditEmployee: boolean;
    editEmployee: string;
    Employeedata: EmployeeBO;
    EmployeefilterDetails: getEmployee = new getEmployee();
    isEmployeefilterEnable: boolean = false;
}

export class getEmployee {
    searchColumn: string = "Name";
    searchText: string = "";
    orderColumn: string = "Name";
    orderType: string = "asc";
    pageitem: number = 10;
    currentpageno: number = 1;
    statusLid: string;
    employeeTypeLi: string;
    field: string = "Name";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
    type: string = "string";
    locationLid: string = "00000000-0000-0000-0000-000000000000";
    message: string;
}

export class ContactInfoLst {
    id: string = "00000000-0000-0000-0000-000000000000";
    name: string;
    street: string;
    city: string;
    state: string;
    zipCode: string;
    county: string;
    phoneNumber: string;
    alternatePhoneNumber: string;
    fax: string;
    email: string;
    contactTypeLid: string;
    relationshipLid: string;
    phoneCarrierLid: string;
    employeeId: string;
    clientId: string;
    contactTypeName: string;
    relationshipName: string;
    phoneCarrierName: string;
    showAdditionalDetails: boolean = false;
}

export class IsViewEditpayrate {
    isView: boolean;
    isEdit: boolean;
    isEditPayorrate: boolean;
    employeeId: string;
    payrateId: string;
    payratetype: string;
    payrate: EmployeePayrateBO[]
    updatedata: any
}

export class EmployeePayrateBO {
    id: string = "00000000-0000-0000-0000-000000000000";
    startDate: string;
    endDate: string;
    rate: number;
    clientId: string | null;
    clientName: string;
    employeeId: string;
    employeeName: string;
    serviceId: string;
    serviceName: string;
    agencyId: string;
    isadded: boolean = false;
}

export class EmployeeBO {
    id: string = "00000000-0000-0000-0000-000000000000";
    agencyId: string;
    firstName: string;
    lastName: string;
    middleName: string;
    type: boolean;
    dOB: string;
    dob: string;
    genderLid: string;
    statusLid: string;
    statusLidName: string;
    totalhours: number | null;
    employeeTypeLid: string | null;
    employeeTypeLids: string[];
    employeeTypeLidName: string;
    age: number | null;
    aKA: string;
    uMPI: string;
    ssn: string;
    aka: string;
    umpi: string;
    maritalStatusLid: string | null;
    rNNPI: string;
    rnnpi: string;
    street: string;
    apt: string;
    email: string;
    phone1: string;
    phone2: string;
    steet: string;
    city: string;
    county: string;
    zipcode: string;
    sSN: string;
    sSNlast4digits: string;
    pEmployeeId: number | null;
    officeStaff: boolean;
    locationName: string;
    pCACertificateNumber: string;
    pcaCertificateNumber: string;
    locationId: string | null;
    requiredEVV: boolean = false;
    primaryJobId: string | null;
    veteranDisabledLid: string | null;
    disabilityLid: string | null;
    raceEthnicityLid: string | null;
    hiredate: string | null;
    inactivedate: string | null;
    terminationdate: string | null;
    workingHours: number | null;
    loginUserId: string;
    exceededHours: number | null;
    name: string;
    username: string;
    password: string;
    gender_Name: string;
    tempEmployeeId: number | null;
    iVREmployeeId: string;
    isEligibleForManualETimeSheet: boolean;
    immunizationLids: string[];
    languageLid: string[];
    // languages:string[];
    driverLicense: string;
    placeofBirth: string;
    driverLicenseExpirydate:string;
}

export class GetEmployeeListBO {
    currentpageno: number = 1;
    pageitem: number = 10;
    orderColumn: string = "name";
    orderType: string = "asc";
    type: string = "string";
    field: string = "name";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "contains";
    employeeID: string | null;
    locationID: string | null;
    employeeTypeLid: string | null;
    isUMPI: boolean | null;
    statusLid: string | null;
}

export class payrateGridBO {
    spendownfilter: boolean | null;
    ptype: string | null;
    role: string;
    user: string | null;
    menuID: string | null;
    parentMenuID: string | null;
    searchColumn: string;
    searchText: string;
    stage: string;
    listId: string | null;
    groupId: string | null;
    lovCode: string;
    userId: string | null;
    agencyId: string | null;
    isEvv: boolean;
    formtype: string;
    formuserId: string;
    employeeId: string;

    locationId: string | null;
    supervisorId: string;
    statusLid: string;
    contactTypeLid: string;
    relationshipLid: string;
    onboardLid: string;
    typefor: string;
    requestStatusLid: string | null;
    vendorId: string | null;
    submittedDate: string | null;
    startDate: string | null;
    endDate: string | null;
    orderColumn: string = "ClientName";
    orderType: string = "asc";
    pageitem: number = 10;
    clientId: string;
    ages: number | null;
    client: string;
    currentpageno: number = 1;
    field: string = "ClientName";
    value: string = "";
    matchCase: boolean = false;
    type: string = 'string';
    operator: string = "contains";
    employeeID: string;
    relationshipFilter: number | null;
    agency: number | null;
}

export class SendToPortalBO {
    employeeId: string;
    agencyNote: string;
    portalLink: string;
    username: string;
}

export class functionpermission {
    employeecreate: boolean = true;
    employeeupdate: boolean = true;
    payorrequiredcreate: boolean = true;
    payorrequireddelete: boolean = true;
    payorrequiredupdate: boolean = true;
    payratescreate: boolean = true;
    payratesdelete: boolean = true;
    payratesupdate: boolean = true;
    payrollinfocreate: boolean = true
    payrollinfoupdate: boolean = true
    payrollinfosave: boolean = true
    employeenotescreate: boolean = true
    employeenotesupdate: boolean = true
    employeenotesdelete: boolean = true
    payratecreate: boolean = true
    payrateupdate: boolean = true
    payratedelete: boolean = true

    employeedocumentcreate: boolean = true
    employeedocumentupdate: boolean = true
    employeerelationshipcreate: boolean = true
    employeerelationshipupdate: boolean = true

}

export class GetpayeridBO {
    orderColumn: string = "PayorName";
    orderType: string = "asc";
    pageitem: number = 10;
    clientId: number;
    ages: number | null;
    client: string;
    currentpageno: number = 1;
    field: string = "PayorName";
    value: string = "";
    matchCase: boolean = false;
    type: string = 'string';
    operator: string = "contains";
    employeeID: string | null;
    relationshipFilter: number | null;
    agency: number | null;
}

export class IsViewEditpayorequired {
    isView: boolean;
    isEdit: boolean;
    isEditPayorRequired: boolean;
    employeeId: string;
    payorRequiredId: string;
    payorRequired: PayorRequiredIDBO[];
    payorActiotype: string;

}
export class PayorRequiredIDBO {
    id: string = "00000000-0000-0000-0000-000000000000";
    payerId: string;
    employeeId: string;
    billingPayerRequiredId: string;
    startDate: string;
    endDate: string | null;
    isReceived: string;
    payorName: string;
}
export class columnWidth {
    column: string = "";
    width: number = 0;
}

export class ColumnChangeBO {
    id: number = 0;
    userid: number = 0;
    agencyId: number = 0;
    column: string;
}


export class WagesSaveBo {
    id:string="00000000-0000-0000-0000-000000000000";
    employeeId:string;
    amount:number;
    month:string;
    year:string;
    empWagDate:string;
}

export class GetListBase {
    currentpageno: number;
    pageitem: number;
    orderColumn: string;
    orderType: string;
    type: string;
    field: string;
    operator: string;
    value: string;
    matchCase: boolean;
}




export class GetEmployeeWagesList  {
    currentpageno: number=1;
    pageitem: number=10;    
    type: string = 'string';
    field: string='employeeName';
    operator: string = "contains";
    value: string='';
    matchCase: boolean=false;
    agencyId: string;
    employeeId: string;
    empWagDate: string;
    amount: number;
    employeeName:string;
    orderColumn: string = "employeeName";
    orderType: string = "asc";
    logType:string;
}

export class GetEmployeeWagesLogsList {
    currentpageno: number=1;
    pageitem: number=10;    
    type: string = 'datetimeoffset';
    field: string='createdTime';
    operator: string = "lessthan";
    value: string='';
    matchCase: boolean=false;
    agencyId: string;
    employeeId: string;
    empWageYear: string;
    totalWages: number;
    employeeName:string;
    orderColumn: string = "createdTime";
    orderType: string = "desc";
    logType:string="null";
    Year:number;
}